import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {USER_LOCALSTORAGE_KEY} from "../../../../../shared/const/localstorage";
import {errorMessage, successMessage, successResponse} from "features/model/slice/lessons/reviewLessonSlice";



interface ReviewLessonArguments {
    reviewLesson: IReviewLessonData;
    lessonsId: string | undefined;
}

interface IReviewLessonData {
    text: string;
    points: number;
}

export const fetchReviewLesson = createAsyncThunk(
    'lessons/fetchReviewLesson',
    async ({reviewLesson, lessonsId}: ReviewLessonArguments, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);

            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }

            const {token} = JSON.parse(authToken);

            const requestReviewLesson = {
                text: reviewLesson.text,
                points: reviewLesson.points,
            };

            const response = await axios.post(`/api/lessons/${lessonsId}/feedback`, requestReviewLesson, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.success) {
                thunkAPI.dispatch(successMessage(response.data.message));
            }

            if (!response.data.success) {
                thunkAPI.dispatch(errorMessage(response.data.error));
                throw new Error('Ошибка при отправке отзыва на сервер');
            }

            thunkAPI.dispatch(successResponse(response.data.success));

            return response.data;
        } catch (error) {
            // Обработка ошибки и передача её внутрь createAsyncThunk
            throw error;
        }
    }
);
